export default __webpack_public_path__ + "static/media/Sequence 09.18b3ec58.mp4";